import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreditNoteModel } from '@app/core/Models';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { CommonService } from '../..';

@Injectable({
  providedIn: 'root',
})
export class CreditNoteService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  createCreditNote(creditNote: CreditNoteModel): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${environment.apiVersionUrl}CreditNote/save`,
      this.commonService.trimObjectSpace(JSON.stringify(creditNote)),
      headers
    );
  }

  getDataByCreditNoteId(creditNoteId: Guid): Observable<CreditNoteModel> {
    return this.http.get<CreditNoteModel>(
      `${environment.apiVersionUrl}CreditNote/get/${creditNoteId}`
    );
  }

  deleteCreditNote(creditNoteIds?: Array<Guid>): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: this.commonService.trimObjectSpace(JSON.stringify(creditNoteIds)),
    };
    return this.http.delete<any>(
      `${environment.apiVersionUrl}CreditNote/delete`,
      options
    );
  }

  copyCreditNote(creditNoteIds?: Array<Guid>): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.put<any>(
      `${environment.apiVersionUrl}CreditNote/copyCreditNote`,
      this.commonService.trimObjectSpace(JSON.stringify(creditNoteIds)),
      headers
    );
  }

  archiveAndRestoreCreditNote(
    creditNoteIds?: Array<Guid>,
    isArchive?: boolean
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.patch<any>(
      `${environment.apiVersionUrl}CreditNote/archive/${isArchive}`,
      this.commonService.trimObjectSpace(JSON.stringify(creditNoteIds)),
      options
    );
  }
}
